import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { App } from './App.js';
import { SessionProvider } from './lib/session.js';
import { ApiError } from './lib/api.js';
import './styles/app.css';

/* ============================================================================
   Entry point.
   ========================================================================== */

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      /* A dashboard checked from a shop is opened, glanced at and put away.
         Refetching on focus is what makes the numbers right when it is picked
         back up, so it stays on. */
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Retrying a 401 or a 422 just repeats a definite answer. Only retry
        // the ones that might genuinely differ next time.
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
